module.exports = __webpack_public_path__ + "fonts/GothamSSm-LightItalic_Web.819fd25.woff2";